import {DateRange} from "react-day-picker";

import {FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";

import {FilterCategory, FilterCategoryType, MatchMode} from "../FilterDropdown.ts";
import {ArrayOptions} from "./ArrayOptions.tsx";
import {DateRangeOptions} from "./DateRangeOptions.tsx";
import {GraphqlOptions} from "./GraphqlOptions.tsx";

interface RightPaneFactoryProps {
  category: FilterCategory;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  localFilterSets: FilterSets<FilterCategory>;
  totalOptions: number | null;
  setTotalOptions: (total: number | null) => void;
  onToggleOption: (categoryId: string, optionValue: string) => void;
  onChange: (categoryId: string, range: DateRange | undefined) => void;
  onMatchModeChange: (categoryId: string, mode: MatchMode) => void;
}

export const RightPaneFactory = ({category, ...props}: RightPaneFactoryProps) => {
  switch (category.type) {
    case FilterCategoryType.RANGE:
      return <DateRangeOptions category={category} {...props} />;
    case FilterCategoryType.ARRAY:
      return <ArrayOptions category={category} {...props} />;
    case FilterCategoryType.GQL:
      if (!category.graphql) {
        return null;
      }
      return <GraphqlOptions category={category} {...props} />;
    default:
      return null;
  }
};
